import { render, staticRenderFns } from "./onlineApproval.vue?vue&type=template&id=f057322c"
import script from "./onlineApproval.vue?vue&type=script&lang=js"
export * from "./onlineApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports